<template>
  <body class="main-body">
    <!-- モーダル画面 -->
    <div style="display: flex;">
      <ModalCreateScenario
        :isShowModal="isCreateScenario"
        :addScenario="addScenario"
        :prevScenarioData="prevScenarioData"
        :nextScenarioData="nextScenarioData"
        @cancel="changeModalCreateScenario"
        @create-scenario="createScenario"
        v-if="isCreateScenario"
      />
      <ModalEditScenario :PCTRLLOG="CTRLLOG"/>
    </div>
    <div class="flex-container">
      <div class="company-header">
       <div class="edit-scenario-wrapper">
          <div style="width: 48%;">
            <div class="tabs is-toggle is-small" style="display: contents;">
              <ul>
                <li :class="{'is-active': !isDemoEditScenario}">
                  <a @click="isDemoEditScenario=false">プレビューモード</a>
                </li>
                <li :class="{'is-active': isDemoEditScenario}" >
                  <a @click="isDemoEditScenario=true ">編集モード</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="restart-btn-wrapper">
          <a class="button is-primary" @click="openEditingPage()" v-if="isAuth">
            <span class="mdi mdi-square-edit-outline">シナリオ編集画面に移動</span>
          </a>
        </div>
        <div class="msg-wrapper" v-if="isAuth">
          <p>※編集後の内容は「Startに戻る」または「リロード」で確認できます。</p>
          <p>※一度ロボ切替が発生すると編集できなくなります。切替先のシナリオを編集するようにしてください。</p>
        </div>
        <div class="restart-btn-wrapper">
          <a class="button is-primary" @click="restart()" v-if="isAuth">
            <span class="mdi mdi-restart">Startに戻る</span>
          </a>
        </div>
        <div class="demo-title-wrapper">
          <h1 class="demo-title">デモ画面</h1>
        </div>
      </div>
      <!-- チャット画面 -->
      <div class="main-container" v-if="isMessage">
        <div class="chat-dialog disp-scroll" v-if="chatLogs.length === 0">
          <span class="mdi mdi-loading mdi-spin"></span>
        </div>
        <transition name="slide">
          <div class="chat-dialog disp-scroll" @dblclick="nextScenario()" v-if="chatLogs.length">
            <draggable
              id="bln-drag-list"
              :list="chatLogs"
              @start="changeDrag(true)"
              @end="saveScenarioOrder(chatLogs)"
              :options="{
                animation: 300,
                group: {
                  name: 'TEMP',
                  pull: 'clone',
                  put: false
                },
                handle: '.drag-button'
              }">
              <div
                style="position: relative;"
                v-for="(chat, index) in chatLogs"
                :key="index"
                @dragover="dragEnter(index, $event)"
              >
                <button
                  class="drag-button"
                  v-if="(chat.speaker === 'other') && isDemoEditScenario">
                  <span class="mdi mdi-drag"></span>
                </button>
                <Balloon
                  @pushChat="pushChat"
                  @scenarioEdit="scenarioEdit"
                  @restart="restart"
                  :speaker="chat.speaker ? chat.speaker : 'other'"
                  :name="chat.name"
                  :icon="chat.icon"
                  :message="chat.message"
                  :time="displayDate(chat)"
                  :readTime="new Date()"
                  :isBot="chat.isBot"
                  :email="chat.email"
                  :isManager="chat.isManager"
                  :logIndex="index"
                  :lastIndex="chatLogs.length - 1"
                  :companyID="companyid"
                  :scnName="scnName"
                  :isDemo="true"
                  :isDemoEditScenario="isDemoEditScenario"
                  :status="chat.status"
                  :parameter="chat.parameter"
                  :companyData="widgetDataDemo"
                  :scenarioData="chat"
                  :isAuth="isAuth"
                  :roboPartsSetOutsideScenario="roboPartsSetOutsideScenario"
                  :roboPartsSetNextNode="roboPartsSetNextNode"
                  :isConfirm="getConfirm(chat.pk)"
                  @updateMainMessage="updateMainMessage">
                </Balloon>
                <button
                  class="add-button"
                  :class="{'add-button-anim': addScenario.idx === addButtonIdx}"
                  @dragover="dragOverButton(index)"
                  @dragover.prevent
                  @drop="dropScenario"
                  v-if="addScenario.flg && addScenario.idx === index && chatLogs.length > addScenario.idx + 1 && !isDrag">
                  <span class="mdi mdi-plus -right-8px"></span>
                  ここにパーツを追加
                </button>
              </div>
            </draggable>
            <MogoMogo v-if="isSCNLoading||isRecommendScheduleLoading"/>
            <div style="height: 42px; width: 200px;" v-else></div>
            <div style="height: 176px;"></div>
            <div
              class="tap-box"
              v-if="(chatLogs[chatLogs.length-1].status == 2  ||
                     chatLogs[chatLogs.length-1].status == 5  ||
                     chatLogs[chatLogs.length-1].status == 14 ||
                     chatLogs[chatLogs.length-1].status == 19)"
            >
              <div v-if="!talkEnd">
                <div class="huyuu">
                  <span class="mdi mdi-gesture-double-tap mdi-36px"></span>
                </div>
                <div>ダブルクリックをすることで<br>次へ進みます。</div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="loading-container" v-else>
        <span v-if="!isNoStartScenerio" class="mdi mdi-loading mdi-spin mdi-48px"></span>
        <span v-else>シナリオの開始が設定されていません。</span>
      </div>
      <div class="scenario-container disp-scroll" v-if="isAuth && isDemoEditScenario">
        <ScenarioParts
          :isParts="true"
          :roboLock="selectChatbot.is_confirm"
          :scenarioTable="scenarioTable"
          @dragScenarioParts="dragScenarioParts"
          @resetDrag="resetDrag"
        />
      </div>
    </div>
  </body>
</template>

<script>
import { mapState }        from 'vuex'
import draggable           from 'vuedraggable'
import Balloon             from '@/components/ui/Balloon'
import MogoMogo            from '@/components/ui/MogoMogo'
import watchScenarioMixin  from '@/mixins/watchScenarioMixin'
import ModalEditScenario   from '@/components/ui/ModalEditScenario'
import makeScenarioFunc    from '@/functions/makeScenarioFunc'
import cardList            from '@/assets/json/master/scenario.json'
import ScenarioParts       from '@/views/DashBoard/ChatBot/ScenarioParts'
import ModalCreateScenario from '@/components/ui/ModalCreateScenario'
import alterReplace from '@/functions/alterStrReplace'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    draggable,
    Balloon,
    MogoMogo,
    ModalEditScenario,
    ScenarioParts,
    ModalCreateScenario
  },
  mixins: [watchScenarioMixin, controlLogMixin],
  data () {
    return {
      isDemo: true,
      weekday: [
        '日', '月', '火', '水', '木', '金', '土'
      ],
      isMessage: false,
      height: 45,
      num: null,
      companyid: null,
      scnName: null,
      chatData: {
        beforenode: '',
        message: '',
        name: '',
        url: '',
        email: '',
        speaker: 'my',
        icon: '',
        createdAt: '',
        isManager: '0',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0
      },
      Logs: [],
      isOnceNavi: false,
      chatLen: false,
      isAuth: false,
      isEdit: false,
      isDrag: false,
      addScenario: {
        idx: -1,
        flg: false,
        status: -1
      },
      cardList: cardList,
      addButtonIdx: -2,
      isCreateScenario: false,
      prevScenarioData: null,
      nextScenarioData: null,
      beforeChatLogs: [],
      isDemoEditScenario: false
    }
  },
  computed: {
    ...mapState('auth',       ['user', 'users']),
    ...mapState('directtalk', ['color', 'widgetDataDemo', 'chatLogs', 'chatTalkHistory']),
    ...mapState('chatbot', ['chatbot', 'scenarioTable', 'scenario', 'isSwitch', 'chatbots', 'isSCNLoading', 'isNoStartScenerio', 'isAutomatic', 'talkEnd', 'minipk', 'selectChatbot', 'roboPartsSetOutsideScenario', 'roboPartsSetNextNode']),
    ...mapState('calendar', ['schedule', 'recommendDate', 'isRecommendScheduleLoading', 'preserveSuggestedSchedulesList']),
  },
  mounted () {
    // window.addEventListener('focus', this.focusIn)
    this.companyid = this.$route.params.companyid
    this.scnName = this.$route.params.scnName
    // アカウント情報取得
    this.$store.dispatch('auth/getAccountDetails')
    // ローカルストレージの初期化
    localStorage.removeItem('NM_demo')
    localStorage.removeItem('EM_demo')
    localStorage.removeItem('TL_demo')
    localStorage.removeItem('AD_demo')
    localStorage.removeItem('FR_demo')
    localStorage.removeItem('SH_demo')
    localStorage.removeItem('GK_demo')
    localStorage.removeItem('BK_demo')
    localStorage.removeItem('SC_demo')
    localStorage.removeItem('DEMO_DEFAULT_NM')
    localStorage.removeItem('DEMO_DEFAULT_EM')
    localStorage.removeItem('DEMO_DEFAULT_TL')
    localStorage.removeItem('DEMO_DEFAULT_AD')
    localStorage.removeItem('DEMO_DEFAULT_FR')
    localStorage.removeItem('SCR')
    localStorage.removeItem('msg')
    // 訪問者情報の割当
    this.$store.dispatch('directtalk/getRoomDemo', this.companyid)
    this.$store.dispatch('chatbot/setMiniPK', this.$route.params.minipk)
    this.$store.dispatch('chatbot/getScenarioOne',
      {
        companyid   : this.companyid,
        scenarioName: this.scnName,
        node        : 'INITIALIZE',
        rate        : this.color.thinking_rate,
        minipk      : this.minipk
      }
    )
    // chatbot情報の取得
    this.$store.dispatch('chatbot/getChatBotOne', 
      {
        companyid:     this.$route.params.companyid,
        scenario_name: this.$route.params.scnName
      }
    )
  },
  watch: {
    chatLogs () {
      this.chatLen = false
      if (this.chatLogs.length !== 0) {
        this.$nextTick(() => {this.scrollDown()})
      }
    },
    isNoStartScenerio () {
      if (this.isNoStartScenerio) alert('開始位置が設定されていません')
    },
    user () {
      if (this.user.username && (this.user.isAgent || this.user.companyID == this.companyid)) {
        // アカウント情報が取得できたら、編集に必要な情報を取得
        // アカウント情報が取得できなければ編集させない
        this.isAuth = true
        this.$store.dispatch('auth/getUsers')
        this.$store.dispatch('mediapool/getAllImages')
        this.$store.dispatch('mediapool/getAllVideos')
        this.$store.dispatch('chatbot/getChatBots')
        this.$store.dispatch('chatbot/getScenario',
          {
            companyid   : this.$route.params.companyid,
            scenarioName: this.$route.params.scnName
          }
        )
      }
    }
  },
  methods: {
    pushScenario () {
      const scenarioData = this.makeScenario()
      this.pushChat(scenarioData)
    },
    pushScenarioCalendar () {
      const scenarioData = this.makeScenarioCalendar()
      this.pushChat(scenarioData)
    },
    nextScenario () {
      if (this.isEdit) {
        // 編集ボタンが押下された場合は次に行かない
        this.isEdit = false
        return
      }
      if (!this.chatLen && !this.isSCNLoading && this.chatLogs[this.chatLogs.length-1].status == 2 ||
          this.chatLogs[this.chatLogs.length-1].status == 5  ||
          this.chatLogs[this.chatLogs.length-1].status == 14 ||
          this.chatLogs[this.chatLogs.length-1].status == 19) {
        this.isOnceNavi = true
        this.chatLen = true
        let scenarioName = null
        let nextNode = null
        if (this.scenario.output_flg === true) {
          scenarioName = this.roboPartsSetOutsideScenario
          nextNode = this.roboPartsSetNextNode
        } else {
          scenarioName = this.scenario.name
          nextNode = this.scenario.select[0].next_node
        }
        this.$store.dispatch('chatbot/getScenarioOne',
          {
            companyid   : this.companyid,
            scenarioName: scenarioName,
            node        : nextNode,
            rate        : this.color.thinking_rate,
            minipk      : this.minipk
          }
        )
      }
    },
    makeScenario () {
      let name = ''
      let id = ''
      let icon = ''
      name = this.chatbot.name
      id = this.chatbot.bot_id
      icon = this.chatbot.icon
      let msg = ''
      if (this.scenario.status == 5) {
        msg = '[msg][image]' + this.scenario.image + '[/image][/msg]|' + this.scenario.template
      } else if (this.scenario.status == 10) {
        msg = '[msg]【メール送付】\n' + alterReplace(this.scenario.mainmessage, false) + '[/msg]' + this.scenario.template
      } else if (this.scenario.status == 14) {
        msg = '[msg][movie]' + this.scenario.movie + '[/movie][/msg]' + this.scenario.template
      } else if (this.scenario.status == 12) {
        msg = '[msg]【条件分岐】\n' + this.scenario.mainmessage + '[/msg]|' + this.scenario.template
      } else {
        msg = '[msg]' + this.scenario.mainmessage + '[/msg]|' + this.scenario.template
      }
      let scenarioData = {
        beforenode: this.scenario.beforenode,
        message: msg,
        name: name,
        url: 'demo_scenario',
        email: id,
        speaker: 'other',
        icon: icon,
        isBot: true,
        createdAt: this.getDisplayNowDate(),
        sendToID: '',
        minibot_pk: '',
        sendToModel: '',
        scenarioNode: '',
        btnIdx: 0,
        isManager: '2',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0,
        status: this.scenario.status,
        parameter: this.scenario.parameter,
        quoteFlg: this.scenario.quote_flg,
        pk: this.scenario.pk
      }
      const settingItems = {
        lsApplicant: localStorage.getItem('NM_demo'),
        lsEmail    : localStorage.getItem('EM_demo'),
        lsTel      : localStorage.getItem('TL_demo'),
        lsAddress  : localStorage.getItem('AD_demo'),
        lsFurigana : localStorage.getItem('FR_demo'),
        lsYyyymmdd : localStorage.getItem('BD_demo'),
        lsYears    : localStorage.getItem('YE_demo'),
        lsShikaku  : localStorage.getItem('SH_demo'),
        lsCareer   : localStorage.getItem('GK_demo'),
        lsBikou    : localStorage.getItem('BK_demo'),
        lsSchedule : localStorage.getItem('SC_demo'),
        lsPoint    : localStorage.getItem('SCR')
      }
      let tempChatTalkHistory = this.chatTalkHistory.slice().reverse()

      const scenario = makeScenarioFunc.getScenarioData(
        this.$_.cloneDeep(scenarioData),
        {...settingItems},
        this.$_.cloneDeep(tempChatTalkHistory))
      return scenario
    },
    makeScenarioCalendar () {
      var name = ''
      var id = ''
      var icon = ''
      // ロボを切り替える場合はシナリオ読み込み一回以上している状態
      name = this.chatbot.name
      id = this.chatbot.bot_id
      icon = this.chatbot.icon
      var templateDate = ''
      if (this.recommendDate.start !== 'Initialized') {
        const buttonTagS = '[button]'
        const buttonTagE = '[/button]'
        const pipe = '|'
        for (let i=0; i<this.recommendDate.length; i++) {
          const recDate =
            new Date(this.recommendDate[i].start).getMonth() + 1 + '/' + new Date(this.recommendDate[i].start).getDate() + ' (' +  this.weekday[new Date(this.recommendDate[i].start).getDay()] + ') ' +
            new Date(this.recommendDate[i].start).getHours() +     ':' + ('00' + new Date(this.recommendDate[i].start).getMinutes()).slice(-2) + ' ~ ' +
            new Date(this.recommendDate[i].end).getHours()   +     ':' + ('00' + new Date(this.recommendDate[i].end).getMinutes()).slice(-2)
          templateDate += pipe + buttonTagS + recDate + buttonTagE
        }
      }
      var scenarioData = {
        beforenode: this.scenario.beforenode,
        message: '[msg]' + this.scenario.mainmessage + '[/msg]' + templateDate,
        name: name,
        url: 'demo_scenario',
        email: id,
        speaker: 'other',
        icon: icon,
        isBot: true,
        createdAt: this.getDisplayNowDate(),
        sendToID: '',
        minibot_pk: '',
        sendToModel: '',
        scenarioNode: '',
        btnIdx: 0,
        isManager: '2',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        status: this.scenario.status,
        parameter: this.scenario.parameter,
        count: 0
      }
      return scenarioData
    },
    getChatData (message) {
      return {
        beforenode: message.beforenode,
        message: message,
        name: 'あなた',
        url: 'demo',
        email: '',
        speaker: 'my',
        icon: this.chatbot.icon,
        isBot: false,
        createdAt: this.getDisplayNowDate(),
        isManager: '0',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0,
        status: -1,
        parameter: null,
      }
    },
    submit () {
      if (this.chatData.message !== '') {
        var promise = Promise.resolve()
        promise
          .then(this.pushChat(this.getChatData(this.chatData.message)))
          .then(this.chatData.message = '')
      }
    },
    scrollDown () {
      var nodes = document.querySelectorAll('.chat-timeline');
      var last = nodes[nodes.length- 1];
      if (!last) return
      last.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
    },
    pushChat (pushData) {
      if (pushData.quoteFlg) {
        if (pushData.status == 1 || pushData.status == 8) {
          // 応募フォーム or 履歴書フォーム のとき
          pushData.quoteWords = {
            name:     '__' + pushData.pk + '.name__',
            furigana: '__' + pushData.pk + '.furigana__',
            email:    '__' + pushData.pk + '.email__',
            tel:      '__' + pushData.pk + '.tel__',
            gender:   '__' + pushData.pk + '.gender__',
            address:  '__' + pushData.pk + '.address__',
            birth:    '__' + pushData.pk + '.birth__',
            message:  '__' + pushData.pk + '.message__'
          }
        }
        else if (pushData.status == 15) {
          // プルダウンのとき
          pushData.quoteWords = {answer: '__' + pushData.pk + '__'}
          if (pushData.quoteAnswers) {
            for (let i in Object.keys(pushData.quoteAnswers)) {
              const num = Number(i) + 1
              pushData.quoteWords['pulldown' + num] = '__' + pushData.pk + '.pulldown' + num + '__'
            }
          }
        }
        else {
          pushData.quoteWords = {
            answer: '__' + pushData.pk + '__'
          }
        }
      }
      this.chatLogs.push(pushData)
      this.chatTalkHistory.push(pushData)
    },
    pushSpliceChat (pushData, index) {
      this.chatLogs.splice(index + 1, 0, pushData)
    },
    scenarioEdit (beforenode) {
      this.isEdit = true
      this.$store.dispatch('chatbot/selectDemoScenario', beforenode)
      this.$store.dispatch('chatbot/changeModalEditScenario')
      // シナリオ編集画面に戻った時にリロードされるように保存しておく
      localStorage.setItem('DEMO_EDIT', this.$route.params.scnName)
    },
    restart () {
      this.scnName = this.$route.params.scnName
      localStorage.removeItem('NM_demo')
      localStorage.removeItem('EM_demo')
      localStorage.removeItem('TL_demo')
      localStorage.removeItem('AD_demo')
      localStorage.removeItem('FR_demo')
      localStorage.removeItem('SH_demo')
      localStorage.removeItem('GK_demo')
      localStorage.removeItem('BK_demo')
      localStorage.removeItem('SC_demo')
      localStorage.removeItem('SCR')
      localStorage.removeItem('BK_SCR')
      localStorage.removeItem('msg')
      // 前へ戻るの候補を初期化
      this.$store.dispatch('calendar/resetSuggestedSchedules')
      this.$store.dispatch('directtalk/initializeChatLogs')
      this.$store.dispatch('chatbot/getScenario', {
        companyid: this.companyid,
        scenarioName: this.$route.params.scnName
      })
      this.$store.dispatch('chatbot/getScenarioOne',
        {
          companyid   : this.companyid,
          scenarioName: this.$route.params.scnName,
          node        : 'INITIALIZE',
          rate        : this.color.thinking_rate,
          minipk      : this.$route.params.minipk
        }
      )
      this.$store.dispatch('chatbot/getChatBotOne',
        {
          companyid:     this.$route.params.companyid,
          scenario_name: this.$route.params.scnName
        }
      )
    },
    openEditingPage () {
      let url = process.env.OWN_ENDPOINT + '/client/chatbot?view=scenario&scenario=' + this.scnName
      if (this.user.companyID == this.companyid) {
        window.location.href = url
      } else if (this.user.isAgent) {
        this.$store.dispatch('auth/updateUserCompany', { companyID: this.companyid })
        window.location.href = url
      }
    },
    saveScenarioOrder (logs) {
      let data = {
        prev: this.beforeChatLogs,
        next: this.chatLogs.filter((v) => {
          if (v.speaker) return v.speaker === 'other'
          else return false
        })
      }
      this.$store.dispatch('chatbot/sortScenarioList', data)
        .then(() => {
          alert('変更しました。')
          // シナリオ編集画面に戻った時にリロードされるように保存しておく
          localStorage.setItem('DEMO_EDIT', this.$route.params.scnName)
        })
      this.changeDrag(false)
    },
    changeDrag (flg) {
      this.isDrag = flg
      if (flg) {
        this.beforeChatLogs = this.$_.cloneDeep(
          this.chatLogs.filter((v) => {
            if (v.speaker) return v.speaker === 'other'
            else return false
          })
        )
      } else {
        this.beforeChatLogs = []
      }
    },
    changeAddScenario (idx, flg) {
      this.addScenario = {
        idx: idx,
        flg: flg
      }
    },
    getPartsName (card) {
      return card.name
    },
    getPartsImage (card) {
      return require('../../assets/template/' + card.img)
    },
    dragScenarioParts (i) {
      this.addScenario.flg    = true
      this.addScenario.idx    = -1
      this.addScenario.status = i
    },
    resetDrag () {
      this.addScenario.flg    = false
      this.addScenario.idx    = -1
      this.addScenario.status = -1
      this.addButtonIdx       = -2
    },
    dragEnter (index, event) {
      this.addScenario.idx = index
    },
    dropScenario () {
      const prev = this.scenarioTable[
        this.$_.findIndex(
          this.scenarioTable, ((obj) => {
            return this.chatLogs[this.addScenario.idx].beforenode === obj.beforenode
          })
        )
      ]
      // 末尾の場合
      let next = null
      if (this.addScenario.idx + 1 < this.chatLogs.length) {
        next = this.scenarioTable[
          this.$_.findIndex(
            this.scenarioTable, ((obj) => {
              return this.chatLogs[this.addScenario.idx + 1].beforenode === obj.beforenode
            })
          )
        ]
      }
      this.changeModalCreateScenario(
        true,
        prev,
        next
      )
    },
    changeModalCreateScenario (flg, prev, next) {
      this.isCreateScenario = flg
      this.prevScenarioData = prev
      this.nextScenarioData = next
    },
    createScenario (data, prev, next) {
      this.$store.dispatch('chatbot/saveScenario',
          {
            companyid   : this.user.companyID,
            scenarioName: this.scenarioTable[0].name,
            data        : data
          }
        ).then((d) => {
          this.setCreateChatLogs(d, prev, next)
          // 前のシナリオとつなぐ
          if (prev) {
            let prevModify = this.$_.cloneDeep(prev)
            const index = this.$_.findIndex(
              prevModify.select,
              ((obj) => {
                return obj.next_node === next.beforenode
              })
            )
            prevModify.select[index].next_node = d.beforenode
            this.$store.dispatch('chatbot/setScenario', {
              companyid: this.user.companyID,
              scenarioName: this.scenarioTable[0].name,
              scenario: prevModify
            })
          }
          this.sendControlLogRelatedChatBot('シナリオパーツ編集(デモ画面)', 'プレビュー画面の編集モードにてパーツを追加した。', this.chatbot)
        })
    },
    setCreateChatLogs (data, prev, next) {
      let index = 0
      if (!prev) {
        index = -1
      } else {
        index = this.$_.findIndex(
          this.chatLogs,
          ((obj) => { return obj.beforenode === prev.beforenode })
        )
      }
      const log = this.makeSpliceScenario(data)
      this.pushSpliceChat(log, index)
    },
    makeSpliceScenario (tempdata) {
      let name = this.chatbot.name
      let id = this.chatbot.bot_id
      let icon = this.chatbot.icon_data
      // 画像表示かイメージかで切り替える
      let msg = ''
      if (tempdata.status == 5) {
        msg = '[msg][image]' + tempdata.image + '[/image][/msg]|' + tempdata.template
      } else if (tempdata.status == 10) {
        msg = '[msg]【メール送付】\n' + alterReplace(tempdata.mainmessage, false) + '[/msg]' + tempdata.template
      } else if (tempdata.status == 14) {
        msg = '[msg][movie]' + tempdata.movie + '[/movie][/msg]' + tempdata.template
      } else if (tempdata.status == 12) {
        msg = '[msg]【条件分岐】\n' + tempdata.mainmessage + '[/msg]|' + tempdata.template
      } else {
        msg = '[msg]' + tempdata.mainmessage + '[/msg]|' + tempdata.template
      }
      let scenarioData = {
        beforenode: tempdata.beforenode,
        message: msg,
        name: name,
        url: 'demo_scenario',
        email: id,
        speaker: 'other',
        icon: this.chatbot.icon,
        isBot: true,
        createdAt: this.getDisplayNowDate(),
        sendToID: '',
        minibot_pk: '',
        sendToModel: '',
        scenarioNode: '',
        btnIdx: 0,
        isManager: '2',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0,
        status: tempdata.status,
        parameter: tempdata.parameter,
        quoteFlg: tempdata.quote_flg,
        pk: tempdata.pk
      }
      const settingItems = {
        lsApplicant: localStorage.getItem('NM_demo'),
        lsEmail    : localStorage.getItem('EM_demo'),
        lsTel      : localStorage.getItem('TL_demo'),
        lsAddress  : localStorage.getItem('AD_demo'),
        lsFurigana : localStorage.getItem('FR_demo'),
        lsYyyymmdd : localStorage.getItem('BD_demo'),
        lsYears    : localStorage.getItem('YE_demo'),
        lsShikaku  : localStorage.getItem('SH_demo'),
        lsCareer   : localStorage.getItem('GK_demo'),
        lsBikou    : localStorage.getItem('BK_demo'),
        lsSchedule : localStorage.getItem('SC_demo'),
        lsPoint    : localStorage.getItem('SCR')
      }
      let tempChatTalkHistory = this.chatTalkHistory.slice().reverse()
      return makeScenarioFunc.getScenarioData(
        this.$_.cloneDeep(scenarioData),
        {...settingItems},
        this.$_.cloneDeep(tempChatTalkHistory))
    },
    updateMainMessage (message, oldMessage, index) {
      if (window.confirm('パーツ内容を変更しますか？')) {
        this.sendControlLogRelatedChatBot('シナリオパーツ編集(デモ画面)', 'プレビュー画面の編集モードにてパーツの内容を編集した。', this.chatbot)

        let updateScenarioData = this.scenarioTable[
          this.$_.findIndex(
            this.scenarioTable,
            ((obj) => { return this.chatLogs[index].beforenode === obj.beforenode })
          )
        ]
        updateScenarioData.mainmessage = message
        this.$store.dispatch('chatbot/setScenario', {
          companyid: this.user.companyID,
          scenarioName: this.scenarioTable[0].name,
          scenario: updateScenarioData
        })
          .then(() => {
            alert('変更しました。')
            // シナリオ編集画面に戻った時にリロードされるように保存しておく
            localStorage.setItem('DEMO_EDIT', this.$route.params.scnName)
            this.chatLogs[index].message = this.chatLogs[index].message.replace(oldMessage, message)
          })
      } else {
        alert('キャンセルしました')
      }
    },
    dragOverButton (index) {
      if (this.addScenario.flg) {
        this.addButtonIdx = index
      }
    },
    displayDate (chat) {
      if (!isNaN(chat.createdAt)) {
        return chat.createdAt
      } else {
        return new Date(chat.createdAt)
      }
    },
    getDisplayNowDate () {
      let date = new Date().toISOString()
      if (isNaN(date)) {
        return new Date()
      } else {
        return date
      }
    },
    getConfirm (pk) {
      for (let i of this.scenarioTable) {
        if (i.pk == pk) {
          return i.is_confirm
        }
      }
    }
  },
  beforeDestroy () {
    // window.removeEventListener('focus', this.focusIn)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
html, body {
  width: 100vw;
  height: 100vh;
}
h1 {
  font-size: larger;
  font-weight: 600;
}
.main-body {
  background-color: #ced4d1;
  height: 100vh !important;
}
.flex-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  flex-grow: 1;
  position: relative;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.scenario-container {
  display: none;
  width: 200px;
  background: white;
}
.loading-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.company-header{
  background: #f8f8f8;
  height: 50px;
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.chat-dialog {
  height: 100%;
  //overflow-x: hidden;
  //overflow-y: scroll;
  scroll-behavior: smooth;
  background-color: #fff;
}
.slide-enter-active {
  max-height: 100%;
  animation: slideIn .5s;
  transform-origin: left;
}
.slide-leave-active {
  max-height: 100%;
  animation: slideIn .5s reverse;
  transform-origin: left;
}
@keyframes slideIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.chat-dialog::-webkit-scrollbar {
  //width:  8px;
  //height: 8px;
  //visibility: hidden;
}
.input-button {
  background: transparent;
  border: none;
  resize: none;
  outline:none;
}
.add-button {
  width: calc(100% - 24px);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  height: 64px;
  font-weight: 600;
  cursor: pointer;
  border: dotted 2px #222;
  border-radius: 8px;
  transition: 0.5s;
}
.add-button-anim {
  height: 80px;
}

.parent-form {
  width: 100%;
  background: #F8F8F8;
  border-top: solid thin #CCC;
}
.child-form {
  text-align: center;
  padding-bottom: 0px !important;
  min-height: 45px;
  background: #F8F8F8;
}
textarea {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
  font-size: 18px;
  border: none;
  resize: none;
  outline:none;
  line-height: 25px;
  padding-top: 10px;
  padding-left: 8px;
}
.loading-form {
  height: 20px;
  background-color: transparent;
  font-size: 16px;
}
.loading span {
  display: inline-block;
  margin: 0 -.05em;
  margin-left: 10px;
  animation: loading .7s infinite;
}
.loading span:nth-child(2) {
  animation-delay: .1s;
}
.loading span:nth-child(3) {
  animation-delay: .2s;
}
.loading span:nth-child(4) {
  animation-delay: .3s;
}
.loading span:nth-child(5) {
  animation-delay: .4s;
}
.loading span:nth-child(6) {
  animation-delay: .5s;
}
.loading span:nth-child(7) {
  animation-delay: .6s;
}
@keyframes loading {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
.list {
  height: 80vh;
}
.chat-list-enter-active, .chat-list-leave-active {
  transition: all 1s;
}
.chat-list-enter, .chat-list-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.msg-wrapper {
  text-align: left;
  font-size: 12px;
  padding: 0 16px;
  p {
    margin-top: 8px;
  }
}

.huyuu {
  animation: huwahuwa 2s ease-out;
  animation-iteration-count: infinite;
}
@keyframes huwahuwa {
  0% {
    transform: translateY(0px) scale(0.8);
  }
  50% {
    transform: translateY(-7.5px) scale(0.8);
  }
  100% {
    transform: translateY(0px) scale(0.8);
  }
}
.footer-area {
  display: flex;
  justify-content: space-between;
}
.left-block, .right-block {
  width: 96px;
}
.center-block {
  display: flex;
  justify-content: center;
  align-items: center;
}
.auto-button {
  border-radius: 16px;
}
.tap-box {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  margin: auto;
  height: 160px;
}
.auto-button-wrapper {
  position: absolute;
  bottom: 16px;
  right: 16px;
}
.msg-wrapper, .restart-btn-wrapper, .edit-scenario-wrapper{
  display: none;
}
.demo-title-wrapper {
  display: flex;
  justify-content: center;
  align-content: center;
}
.demo-title {
  display: flex;
  justify-content: center;
  align-items: center;
} 
.restart-btn-wrapper {
  margin-top: 16px;
}
.edit-scenario-wrapper{
  margin-left: 8px;
  margin-top: 224px;
  overflow: auto;
}

@media screen and (min-width: 768px) {
  h1 {
    font-size: larger;
  }
  .flex-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .company-header {
    height: 100%;
    width: 30%;
  }
  .chat-dialog {
    height: 100%;
  }
  .main-container {
    height: 100%;
    width: 45%;
    flex-grow: 0;
  }
  .loading-container {
    height: 100%;
    width: 45%;
  }
  .msg-wrapper, .restart-btn-wrapper, .edit-scenario-wrapper {
    display: block;
  }
  .scenario-container {
    display: block;
  }
  .demo-title {
    margin-top: 208px;
  }
}
.drag-button {
  border: solid thin #ccc !important;
  position: absolute;
  left: 13.5px;
  top: 108px;
  background: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/ChatSinglePage/ChatSingleDemoView.vue